<template>
  <div id="integrationsSSO" class="margin-subpages">
    <div class="sub-title">{{ $t('integrations.sso.selectMethod') }}</div>
    <div class="line-style my-16" />
    <div class="flex-row-between mt-14">
      <div style="width: 320px">
        <el-menu class="input-select" mode="horizontal">
          <el-submenu index="0" style="width: 320px">
            <template slot="title">
              <span class="text-dropdown" id="ssoMethod">SAML</span>
            </template>
            <el-menu-item
              index="1"
              @click="sortBy('SAML')"
              style="font-size: 14px; width: 320px"
              >SAML</el-menu-item
            >
            <!-- <el-menu-item
              index="1"
              @click="sortBy('name')"
              style="font-size: 14px; width: 320px"
              >name</el-menu-item
            > -->
          </el-submenu>
        </el-menu>
      </div>
    </div>
    <div class="sub-title mt-32">{{ $t('integrations.sso.general') }}</div>
    <div class="line-style my-16" />
    <div class="grid-2-parameter">
      <div class="title flex-center">{{ $t('integrations.sso.providerId') }}</div>
      <div class="">
        <el-input
          :placeholder="$t('integrations.sso.providerIdPlaceholder')"
          class="input gray"
          v-model="selectedSso.ssoProviderId"
          disabled
        ></el-input>
      </div>
      <div class="title flex-center">{{ $t('integrations.sso.connectionName') }}</div>
      <el-input
        :placeholder="$t('integrations.sso.connectionNamePlaceholder')"
        class="input"
        v-model="selectedSso.connectionName"
        @keyup.native="handleCannectionNameChange"
        :class="{ 'validate-input': !validation.connectionName }"
      ></el-input>
      <div class="title flex-center">{{ $t('integrations.sso.entityId') }}</div>
      <el-input
        :placeholder="$t('integrations.sso.entityId')"
        class="input"
        v-model="selectedSso.idpEntityId"
        :class="{ 'validate-input': !validation.idpEntityId }"
      ></el-input>

      <div class="title flex-center">{{ $t('integrations.sso.signInUrl') }}</div>
      <el-input
        placeholder="https://samlp.example.com/login"
        class="input"
        v-model="selectedSso.ssoUrl"
        :class="{ 'validate-input': !validation.ssoUrl }"
      ></el-input>
      <div class="title flex-center" style="height: 52px">{{ $t('integrations.sso.certificate') }}</div>
      <el-input
        type="textarea"
        class="input"
        :rows="8"
        :placeholder="$t('integrations.sso.certificatePlaceholder')"
        v-model="selectedSso.certificate"
        :class="{ 'validate-input': !validation.certificate }"
      >
      </el-input>
      <div class="title flex-center opa-05">{{ $t('integrations.sso.syncProfileAttributes') }}</div>
      <div class="opa-05 mt-22">
        <template>
          <el-checkbox v-model="syncProfileAttributes" disabled
            >{{ $t('integrations.sso.syncAtLogin') }}</el-checkbox
          >
        </template>
        <div
          class="pl-40 fc-3B3B3B fs-14 mb-8 opa-07"
          style="width: 580px; margin-top: -2px"
        >
          {{ $t('integrations.sso.syncAtLoginDesc') }}
        </div>
      </div>
    </div>

    <div class="sub-title mt-32">{{ $t('integrations.sso.setupInfo') }}</div>
    <div class="line-style my-16" />
    <div class="grid-2-parameter">
      <div class="title flex-center">{{ $t('integrations.sso.entityId') }}</div>
      <div @click.prevent="copyApiKeyProd(selectedSso.spEntityId)" class="cursor-pointer">
        <el-input
          :placeholder="$t('integrations.sso.entityId')"
          class="input gray copy-input"
          v-model="selectedSso.spEntityId"
          disabled
        ></el-input>
      </div>
      <div class="title flex-center">{{ $t('integrations.sso.authCallbackUrl') }}</div>
      <div
        @click.prevent="copyApiKeyProd(selectedSso.acsUrl)"
        class="cursor-pointer"
      >
        <el-input
          :placeholder="$t('integrations.sso.authCallbackUrl')"
          class="input gray copy-input"
          v-model="selectedSso.acsUrl"
          disabled
        ></el-input>
      </div>
      <div class="title flex-center">{{ $t('integrations.Enable') }}</div>
      <div class="flex-center">
        <div class="switch">
          <div class="can-toggle">
            <input
              class="input"
              type="checkbox"
              id="happilyAssistAccess_checked"
              v-model="selectedSso.enabled"
            />
            <label
              for="happilyAssistAccess_checked"
              :class="`${selectedSso.enabled ? 'power-on' : 'power-off'}`"
            >
              <div class="switch-body flex-mid">
                <div v-if="selectedSso.enabled" class="mr-auto ml-14 mt-2">
                  {{ $t('integrations.sso.on') }}
                </div>
                <div v-else class="ml-auto mr-10 mt-2">{{ $t('integrations.sso.off') }}</div>
              </div>
            </label>
          </div>
        </div>
        <span class="fc-4A4A4A fs-14 fw-700 ml-16"
          >{{ $t('integrations.sso.ssoEnabledLabel') }}</span
        >
      </div>
      <div>&nbsp;</div>
      <div class="mt-32">
        <el-button class="btn-save" type="primary" @click="saveChanges"
          >{{ $t('integrations.Save_Changes') }}</el-button
        >
      </div>
    </div>

    <div v-if="!selectedSso.new && selectedSso.enabled">
      <div class="sub-title mt-32">{{ $t('integrations.sso.dangerZone') }}</div>
      <div class="line-style my-16" />
      <div class="danger-zone-card flex-center">
        <div class="">
          <div class="fs-18 fw-700">{{ $t('integrations.sso.deleteConnection') }}</div>
          <div class="fs-15 mt-6" style="width: 327px">
            {{ $t('integrations.sso.deleteConnectionDesc') }}
          </div>
        </div>
        <div class="ml-auto">
          <el-button
            class="btn-remove-connection"
            type="primary"
            @click="deleteConnection"
            >{{ $t('integrations.sso.removeConnection') }}</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { normalize } from "path";
export default {
  name: "SSO",
  async created() {
    await this.init()
  },
  computed: {
    selectedSso() {
      return this.$store.getters["integrations/selectedSso"];
    },
  },
  data() {
    return {
      syncProfileAttributes: true,
      dropdownSelected: "SAML",

      validation: {
        ssoProviderId: true,

        connectionName: true,
        idpEntityId: true,
        ssoUrl: true,
        certificate: true,

        spEntityId: true,
        acsUrl: true,
      },
    };
  },
  methods: {

    async init () {
    const sso_configuration = await this.$store.dispatch(
      "integrations/getSsoConfiguration"
    );

    // @see https://support.google.com/cloudidentity/answer/6349809?hl=th
    const acsUrl = process.env.VUE_APP_ACS_URL;

    const options = sso_configuration.options || [];
    let selectedSso = null;

    if (options.length) {
      for (var i in options) {
        let selected = options[i].selected || false;
        if (selected) {
          selectedSso = options[i];
          break;
        }
      }
    } else {
      // default
      const company = await this.$store.dispatch("integrations/getUserCompany");
      const connectionName = company.name;
      selectedSso = {
        connectionName: connectionName,
        spEntityId: this._normalizeSsoSamlName(connectionName),
        acsUrl: acsUrl,
        new: true
      };
    }

    this.$store.commit("integrations/selectedSso", selectedSso);
    if (selectedSso.new) {
      this.handleCannectionNameChange({
        target: { value: selectedSso.connectionName },
      });
    }
    },

    _normalizeSsoSamlName(connectionName) {
      return connectionName.replace(/[^a-z0-9]/gi, "").toLowerCase();
    },

    handleCannectionNameChange(event) {
      const selectedSso = this.$store.getters["integrations/selectedSso"] || {};
      const connectionName = event.target.value;

      // default saml sso (cloud identity)
      const PREFIX = "saml.";
      const spEntityId = this._normalizeSsoSamlName(connectionName);
      const ssoProviderId = PREFIX + spEntityId;
      let defaultSamlSso = {...selectedSso, ...{
        connectionName: connectionName,
        acsUrl: selectedSso.acsUrl,
        enabled: false,
        selected: true,
      }}

      // @todo can change only first time. not has id
      if (selectedSso.new) {
        defaultSamlSso.ssoProviderId = ssoProviderId
        defaultSamlSso.spEntityId = spEntityId

        // @fixed for test
        // defaultSamlSso.idpEntityId = "http://www.okta.com/exki87dvlhc6MLqA1696"
        // defaultSamlSso.ssoUrl = "https://happily.okta.com/app/happily_linecorpdevsaml_1/exki87dvlhc6MLqA1696/sso/saml"
        // defaultSamlSso.certificate = "-----BEGIN CERTIFICATE-----"
      }

      this.$store.commit("integrations/selectedSso", defaultSamlSso);
    },
    onClickButton(event) {
      this.$emit("clicked", event);
    },
    copyApiKeyProd(value) {
      const clipboardData = window.clipboardData || navigator.clipboard;
      clipboardData.writeText(value);
      this.$message({
        message: "Copy Token to clipboard",
        type: "success",
      });
    },

    // @see https://trello.com/c/T8BVX5fY/1246-sso-as-a-company-admin-i-want-to-be-able-to-enable-and-set-up-sso-so-that-my-employees-can-login-using-their-company-credentials?filter=member:rathasitjearnpasawarn1
    async saveChanges(event) {
      let selectedSso = this.$store.getters["integrations/selectedSso"]

      const isRequired = (value) => {
        return (value != undefined) && (value != "")
      };

      this.validation = {
        ssoUrl: this.validateUrlRex(selectedSso.ssoUrl) && selectedSso.ssoUrl,
        idpEntityId: isRequired(selectedSso.idpEntityId),
        connectionName: isRequired(selectedSso.connectionName),
        certificate: isRequired(selectedSso.certificate),
      }

      if (
        this.validation.ssoUrl &&
        this.validation.idpEntityId &&
        this.validation.connectionName &&
        this.validation.certificate
      ) {
        // console.log("TODO: Fnctions saveChanges is here!");
        if (selectedSso.new) {
          delete selectedSso.new;
        }
        await this.$store.dispatch("integrations/saveSso", selectedSso);
        this.$message({
          message: "Setup is seved.",
          type: "success",
        });
        // this.$message.error('Oops, this is a error message.');
      }
    },
    deleteConnection() {
      let selectedSso = this.$store.getters["integrations/selectedSso"]
      if (selectedSso.new) return

      let self = this

      this.$confirm("This will delete connection. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      })
        .then(async () => {
          // console.log("TODO: Fnctions deleteConnection is here!");
          await self.$store.dispatch("integrations/deleteSso", selectedSso);
          this.$message({
            type: "success",
            message: "Delete completed",
          });
          await self.init()
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
    sortBy(type) {
      console.log("TODO: Selected options!");
      this.dropdownSelected = type;
    },
    validateUrlRex(value) {
      return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(
        value
      );
    },
  },
};
</script>

<style lang="scss" scoped>
#integrationsSSO {
  font-family: 'Lato', 'Kanit', Arial, sans-serif;
}
.grid-2-parameter {
  display: grid;
  grid-template-columns: 240px auto;
  grid-row-gap: 16px;
  row-gap: 16px;
  .title {
    font-weight: 700;
    font-size: 18px;
    color: #4a4a4a;
    margin-right: 24px;
    margin-left: auto;
  }
}
.btn-save {
  min-width: 158px;
  height: 52px;
  padding: 0 24px;
  white-space: nowrap;
  font-size: 18px;
  font-weight: 700;
  background-color: #32c2d5;
  border-color: #32c2d5;
}
.danger-zone-card {
  background-color: #fff0f0;
  border-radius: 6px;
  padding: 30px 32px;
  color: #981a11;
  .btn-remove-connection {
    width: 240px;
    height: 52px;
    font-size: 18px;
    font-weight: 700;
    color: #fff;
    background-color: #f44336;
    border-color: #f44336;
  }
}
</style>
<style lang="scss">
#integrationsSSO .input .el-input__inner {
  color: #3b3b3b;
  font-size: 18px;
  background-color: #fff;
  border-color: #c7c7c7;
  &:focus {
    border-color: #6c30cc;
  }
}
#integrationsSSO .input .el-textarea__inner {
  font-size: 18px;
  padding: 15px;
}
#integrationsSSO .input.gray .el-input__inner {
  background-color: #f7f7f7;
}
#integrationsSSO .input.is-disabled .el-input__inner {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
  cursor: not-allowed;
  &:focus {
    border-color: #e4e7ed;
  }
}
#integrationsSSO .input.copy-input .el-input__inner {
  cursor: pointer;
  color: #3b3b3b;
}
#integrationsSSO .input-select .text-dropdown {
  width: 265px;
  font-size: 18px;
  color: #4a4a4a;
  .label {
    font-size: 18px;
    font-weight: 700;
    color: #4a4a4a;
  }
}
#integrationsSSO .input-select > .el-submenu,
#integrationsSSO .input-select .el-submenu__title,
#integrationsSSO .input .el-input__inner,
#integrationsSSO .el-button.refersh {
  height: 52px !important;
}
#integrationsSSO .input-select > .el-submenu,
#integrationsSSO .input-select .el-submenu__title {
  line-height: 52px !important;
}
#integrationsSSO .el-checkbox {
  .el-checkbox__inner {
    width: 16px;
    height: 16px;
    &:after {
      height: 9px;
      left: 5px;
    }
  }
  .el-checkbox__label {
    font-size: 18px;
    color: #3b3b3b;
  }
  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    background-color: #00000060;
  }
}
</style>
